import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { updateWelcomeScreen } from '../store/globalReducer';

import '../assets/scss/components/welcomeScreen.scss';

import logoImg from '../assets/img/common/logo.svg';
import cloud_1_1 from '../assets/img/common/transition_cloud_1_1.svg';
import cloud_1_2 from '../assets/img/common/transition_cloud_1_2.svg';
import cloud_1_3 from '../assets/img/common/transition_cloud_1_3.svg';
import cloud_2_1 from '../assets/img/common/transition_cloud_2_1.svg';
import cloud_2_2 from '../assets/img/common/transition_cloud_2_2.svg';

export default function WelcomeScreen() {
  const dispatch = useDispatch();

  const isWelcomeScreenHidden = useSelector(state => state.global.isWelcomeScreenHidden);

  const leftCloudVars = {
    initial: { x: '0%', opacity: 1 },
    exit: { x: '-100%', opacity: 0, transition: { duration: 0.85, delay: 0.4, ease: 'easeOut' } }
  };

  const rightCloudVars = {
    initial: { x: '0%', opacity: 1 },
    exit: { x: '100%', opacity: 0, transition: { duration: 0.85, delay: 0.4, ease: 'easeOut' } }
  }

  const handleClick = e => {
    e.preventDefault();
    dispatch(updateWelcomeScreen(true));
  }

  return (
    <AnimatePresence>
      {!isWelcomeScreenHidden && (
        <motion.div className="welcome">
          <motion.div
            className="welcome__textbox"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.5 } }}>
            <figure className="welcome__logo"><img src={logoImg} alt="須崎カミサマップ" /></figure>
            <p className="welcome__text">
              須崎の神さまをめぐる<br className="sp-show" />「須崎カミサマップ」を手に、<br />神さまたちからパワーをもらう<br className="sp-show" />ご利益めぐりに出かけよう！
            </p>
            <div className="welcome__btn"><a href="#" onClick={handleClick}>はじめる</a></div>
          </motion.div>
          <div className="welcome__clouds">
            <motion.div variants={leftCloudVars} initial="initial" exit="exit" className="welcome__cloud welcome__cloud--first"><img src={cloud_1_1} alt="" /></motion.div>
            <motion.div variants={leftCloudVars} initial="initial" exit="exit" className="welcome__cloud welcome__cloud--second"><img src={cloud_1_2} alt="" /></motion.div>
            <motion.div variants={leftCloudVars} initial="initial" exit="exit" className="welcome__cloud welcome__cloud--third"><img src={cloud_1_3} alt="" /></motion.div>
            <motion.div variants={rightCloudVars} initial="initial" exit="exit" className="welcome__cloud welcome__cloud--fourth"><img src={cloud_2_1} alt="" /></motion.div>
            <motion.div variants={rightCloudVars} initial="initial" exit="exit" className="welcome__cloud welcome__cloud--fifth"><img src={cloud_2_2} alt="" /></motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}


